<template>
  <v-menu offset-y 
          rounded="lg"
          :close-on-content-click="autoClose">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        class="pr-0"
      >
        <span class="d-flex align-end flex-column pr-2">
          {{ user.fullname || 'Account' }}
          <small v-if="user.hasGroup"
                 class="grey--text">
            {{ user.groups[0].name }}
          </small>
        </span>
        <v-icon>mdi-chevron-down</v-icon>
        <UserAvatar class="ml-2"
                    v-if="!isMobile"/>
      </v-btn>
    </template>
    <v-list>
      
      <!-- dyamic menu -->
      <v-list-item
        v-for="(item, index) in currentMenu"
        :key="index"
        @click="openMenu(item)"
        :disabled="item.disabled"
      >
        <v-list-item-content>
          <v-list-item-subtitle 
            v-if="item.badge">
            <Badge :item="item"
                   small/>
          </v-list-item-subtitle>
          <v-list-item-title>
            {{ item.label }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <!-- back button -->
      <v-list-item @click="back"
                   v-if="selectedMenu"
                   class="grey lighten-4">
        <v-list-item-title>
          Indietro
        </v-list-item-title>
        <v-list-item-icon>
          <arrow-left-circle-icon size="1.5x" class="grey--text"></arrow-left-circle-icon>
        </v-list-item-icon>
      </v-list-item>
      
      <!-- logout -->
      <v-list-item @click="logout"
                   v-else>
        <v-list-item-title>
          Esci
        </v-list-item-title>
        <v-list-item-icon>
          <unlock-icon size="1.5x" class="grey--text"></unlock-icon>
        </v-list-item-icon>
      </v-list-item>

    </v-list>
  </v-menu>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { ArrowLeftCircleIcon, UnlockIcon } from 'vue-feather-icons'

  import menuMixin from '@/mixins/menu'
  import utility from '@/mixins/utility'

  import Badge from '@/components/Badge'
  import UserAvatar from '@/components/UserAvatar'

   export default {
    
    name: 'UserMenu',

    mixins: [ menuMixin, utility ],

    components:
    {
      ArrowLeftCircleIcon,
      UnlockIcon,
      Badge,
      UserAvatar
    },

    data: () => ({

    }),

    computed:
    {
      ...mapGetters({
        menu: 'menu/user',
        user: 'auth/user'
      })
    },

    methods:
    {
      ...mapActions({
        logout: 'auth/logout'
      })
    },

    load(){}
  }
</script>